import { FC } from 'react';
import { Box } from '@mui/material';

import styles from 'features/insured-person-case/ui/PersonInfo.module.css';
import { useAppSelector } from 'shared/utils/hooks/useRedux';
import { InsuredPerson } from 'entities/insured-person-case/selector';

const PersonInfo: FC = () => {
    const caseData = useAppSelector(InsuredPerson);
    return (
        <Box className={styles.personInfo}>
            <Box className={styles.rightBox}>
                <Box className={styles.itemRow}>
                    <Box className={styles.itemColumn}>
                        <span>Дата рождения</span>
                        <p>{caseData.BirthDate}</p>
                    </Box>
                    <Box className={styles.itemColumn}>
                        <span>Пол</span>
                        <p>{caseData.Gender}</p>
                    </Box>
                    <Box className={styles.itemColumn}>
                        <span>Телефон</span>
                        <p>{caseData.Phone}</p>
                    </Box>
                    <Box className={styles.itemColumn}>
                        <span>Email</span>
                        <p>{caseData.Email}</p>
                    </Box>
                </Box>
                <Box className={styles.itemRow}>
                    <Box className={styles.itemColumn}>
                        <span>Адрес фактического проживания</span>
                        <p>{caseData.Address}</p>
                    </Box>
                </Box>

                <Box className={styles.itemRow}>
                    <Box className={styles.itemColumn}>
                        <span>ФИО латиницей</span>
                        <p>{caseData.FullName}</p>
                    </Box>
                    <Box className={styles.itemColumn}>
                        <span>Уровень должности</span>
                        <p>{caseData.VIP ? 'VIP' : 'Обычный'}</p>
                    </Box>
                    <Box className={styles.itemColumn}>
                        <span>Должность</span>
                        <p>{caseData.Job}</p>
                    </Box>
                </Box>

                <Box className={styles.itemRow}>
                    <Box className={styles.itemColumn}>
                        <span>Номер полиса</span>
                        <p>{caseData.PolicyNumber}</p>
                    </Box>
                    <Box className={styles.itemColumn}>
                        <span>Дата начала действия</span>
                        <p>{caseData.StartDate}</p>
                    </Box>
                    <Box className={styles.itemColumn}>
                        <span>Дата окончания действия</span>
                        <p>{caseData.EndDate}</p>
                    </Box>
                </Box>
            </Box>
            <Box className={styles.leftBox}>
                <Box className={styles.itemRow}>
                    <Box className={styles.itemColumn}>
                        <span>Холдинг</span>
                        <p>{caseData.HoldingName ? caseData.HoldingName : '-'}</p>

                    </Box>
                    <Box className={styles.itemColumn}>
                        <span>Компания/Страхователь</span>
                        <p>{caseData.InsurerName ? caseData.InsurerName : '-'}</p>
                    </Box>
                     <Box className={styles.itemColumn}>
                        <span>Табельный номер</span>
                        <p>{caseData.PersonnelNumber ? caseData.PersonnelNumber : '-'}</p>
                    </Box>
                </Box>

                {caseData.IndividualLimit !== "0" && (
                    <>
                        <Box className={styles.itemColumn}>
                            <span>Индивидуальный лимит</span>
                            <p>{caseData.IndividualLimit}</p>
                        </Box>
                        <Box className={styles.itemColumn}>
                            <span>Остаток по индивидуальному лимиту</span>
                            <p>{caseData.ResidualPremiumBySpecialProgram}</p>
                        </Box>
                    </>
                )}

            </Box>
        </Box>

    );
};

export default PersonInfo;